// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers. The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@eisinc/App/Store/Selectors/SettingsSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import React, { FC, useMemo } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCartState(state, state.pages.orderConfirmation.cartId).value,
    salesPixelMerchantId: getSettingsCollection(state).customSettings.salesPixelMerchantId,
    salesPixelMerchantUrl: getSettingsCollection(state).customSettings.salesPixelMerchantUrl,
});

type Props = ReturnType<typeof mapStateToProps>;

const styles: React.CSSProperties = {
    width: "0",
    height: "0",
    display: "none",
};

const ProductFeedAndSalesPixel: FC<Props> = ({ cart, salesPixelMerchantId, salesPixelMerchantUrl }) => {
    const imageUrl = useMemo(() => {
        if (!salesPixelMerchantId || !salesPixelMerchantUrl || !cart?.cartLines?.length) {
            return null;
        }

        const baseUrl = salesPixelMerchantUrl.replace("{0}", salesPixelMerchantId);

        const pixelParams = cart.cartLines
            .map(cartLine => {
                const rawData = cartLine.properties?.salesPixelData;
                if (!rawData) {
                    return null;
                }

                const data = JSON.parse(rawData);
                return Object.entries(data)
                    .map(([key, value]) => `;${key}=${encodeURIComponent(String(value))}`)
                    .join("");
            })
            .filter(Boolean)
            .join("");

        return pixelParams ? `${baseUrl}${pixelParams}` : null;
    }, [cart?.cartLines, salesPixelMerchantId]);

    if (!imageUrl) {
        return null;
    }

    return <img src={imageUrl} alt={translate("Product Feed and Sales Pixel")} style={styles} />;
};

export default connect(mapStateToProps)(ProductFeedAndSalesPixel);
